import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Testimonials } from "./components/Testimonials";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="app-container">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Testimonials />
        <Footer />
      </main>
    </div>
  );
}

export default App;
